import React, { useEffect, useState } from "react";
import { Bat, Ghost, Spider } from "./sprites";

/**
 * The site-wide layer: a few bats crossing the screen, a spider that comes down
 * from under the header (click it and it bolts), and a ghost that peeks in from
 * the left edge now and then.
 *
 * Fixed above the page but below the header and every MUI popup (see
 * .hw-overlay), and it ignores the pointer everywhere except on the spider.
 *
 * The realtor panel passes `interactive={false}`: there the spider comes down
 * over filter bars and row buttons people are in the middle of pressing, so it
 * lets every click through instead of catching it.
 */
export default function HalloweenOverlay({ interactive }) {
  const calm = interactive === false;
  const [fleeing, setFleeing] = useState(false);

  useEffect(() => {
    if (!fleeing) return undefined;
    // It creeps back down after a while — it lives here, after all.
    const timer = setTimeout(() => setFleeing(false), 9000);
    return () => clearTimeout(timer);
  }, [fleeing]);

  return (
    <div className="hw-overlay" aria-hidden="true">
      <div className="hw-flyer hw-flyer-1">
        <div className="hw-bob">
          <Bat flapSpeed={0.2} />
        </div>
      </div>
      <div className="hw-flyer hw-flyer-2">
        <div className="hw-bob" style={{ animationDelay: "-1.3s" }}>
          <Bat flapSpeed={0.26} />
        </div>
      </div>
      <div className="hw-flyer hw-flyer-3">
        <div className="hw-bob" style={{ animationDelay: "-0.6s" }}>
          <Bat flapSpeed={0.22} />
        </div>
      </div>

      <div className={"hw-spider" + (fleeing ? " hw-spider--flee" : "")}>
        <div className="hw-spider-rope">
          <div className="hw-spider-thread" />
          <Spider
            onClick={calm ? undefined : () => setFleeing(true)}
            style={calm ? { pointerEvents: "none", cursor: "default" } : undefined}
          />
        </div>
      </div>

      <div className="hw-peek">
        <Ghost />
      </div>
    </div>
  );
}
